//hooks
import { useEffect, useState } from "react";
import { NotificationProvider } from "./hooks/context/NotificationContext";
import { UserProvider, UserConsumer } from "./hooks/context/UserContext";
import { useApi } from "./hooks/useApi";

//component
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Notification from "./popup/Notification";
import Loader from "./component/Loader";
import Home from "./page/client/home/Home";
import About from "./page/about/About";
import Contact from "./page/contact/Contact";
import PrivacyPolicy from "./page/privacyPolicy/PrivacyPolicy";
import Profile from "./page/profile/Profile";
import Reservations from "./page/reservations/Reservations";
import MyDriver from "./page/host/MyDriver";
import MyCars from "./page/host/MyCars";
import Client from "./route/Client";
import Driver from "./route/Driver";
import Host from "./route/Host";
import NotFound from "./page/NotFound/NotFound";
import AvailableCars from "./page/client/vehicles/AvailableCars";
import MyClaims from "./page/host/MyClaims";
import RelatedClaims from "./page/relatedClaims/RelatedClaims";
import CarsOffers from "./page/client/carsOffers/CarsOffers";

//css file
import "./App.css";

//api
import { GetProfileApi } from "./api/profile/GetProfileApi";

//react router dom
import {BrowserRouter, Routes,Route,Navigate, useLocation} from 'react-router-dom';

//mui
import { Container } from "@mui/system";
import {requestNotificationPermission,listenForMessages} from "./firebase/notifgicationFireBase";




function AppContent() {
  const [openLoader, setOpenLoader] = useState(false);
  const { setUserData, theme } = UserConsumer();
  const {
    loading: profileLoading,
    error: profileError,
    HandlerApi: profileCars
  } = useApi(GetProfileApi, "GET");

  useEffect(() => {
    const checkTokenAndFetch = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        return
      }
      else {
        setOpenLoader(true);
        const result = await profileCars();
        setUserData(result.data);
        console.log("Get Profile successful:");
        setOpenLoader(false);
      }
    };

    checkTokenAndFetch();
  }, [setUserData]);

  useEffect(() => {
    // requestNotificationPermission();
    listenForMessages();
  }, []);

  return (
    <>
      {
      profileLoading 
      ? <Loader openLoader={openLoader} setOpenLoader={setOpenLoader} /> 
      : 
      <div className="flex flex-col min-h-[100vh]">
        <Header />
        <main className="flex-1 mt-[100px]">
          <Container maxWidth="xl">
            <Routes>
              <Route path="/" element={<Navigate to={theme === "client" ? "client" : theme === "host" ? "host" : "driver"} replace />} />
              <Route path="client" element={<Client/>}>
                <Route index element={<Home />} />
                <Route path="available_cars" element={<AvailableCars />} />
                <Route path="cars_offers" element={<CarsOffers />} />
              </Route>
              <Route path="host" element={<Host/>}>
                <Route index element={<Reservations />} />
                <Route path="my_cars" element={<MyCars />} />
                <Route path="my_drivers" element={<MyDriver />} />
                <Route path="my_claims" element={<MyClaims />} />
              </Route>
              <Route path="driver" element={<Driver/>}>
                <Route index element={<Reservations />} />
              </Route>
              <Route path={`${theme}/reservations`} element={<Reservations />} />
              <Route path={`${theme}/my_related_claims`} element={<RelatedClaims />} />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="privacy_policy" element={<PrivacyPolicy />} />
              <Route path="profile" element={<Profile />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Container>
        </main>
        <Footer />
        <Notification />
      </div>
      }
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <ScrollToTop/>
        <NotificationProvider>
          <UserProvider>
              <AppContent />
          </UserProvider>
        </NotificationProvider>
      </div>
    </BrowserRouter>
  );
}

export default App;


const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
